import axios from "axios";
import { configUrl } from "../../config";

const assignTopicTestsToUser = async (userId, subscriptionId, topicIds) => {
    console.log(userId, subscriptionId, topicIds, 'gettingValsforTestCreation')

    return axios.post(`${configUrl.AssessmentServer}/api/UserSubscription/assignTopicTestsToUser/${userId}/${subscriptionId}`, topicIds)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error?.response?.data, "prevError");
            return {
                messege: error?.response?.data,
                status: error?.response?.status
            }
        });

};
export default {
    assignTopicTestsToUser: assignTopicTestsToUser
}